import React from 'react';
import '../../styles/utility/Loading.css';
import logoShort from '../../assets/images/logo-elpaket-short.png';

const Loading: React.FC = () => {
  return (
    <div className="spinner-overlay">
      <div className="spinner-container">
        <div className="spinner"></div>
        <img src={logoShort} alt="Loading..." className="spinner-logo" />
      </div>
    </div>
  );
};

export default Loading;
